import React  from 'react'
import {compose, setDisplayName, withHandlers, withPropsOnChange } from "recompose";
import { ifElse, always, equals } from "ramda";
import {connect} from "react-redux";

import { nextDropdown } from '../../../../../../actions/dropdown'
import { DropdownMenu } from "../../../../../Shared/DropdownMenu/DropdownMenu";

import './BookInfo.css'
import {getLocaleString} from "../../../../../../locale";
import {formatBytes} from "../../../../../../utilities/utilities";
import {Scrollbars} from "react-custom-scrollbars";

const DROPDOWN_ID = 'BOOK_INFO'
const isActive = equals(DROPDOWN_ID)

const toggleMenu = ({activeDropdown, nextDropdown}) => ({isInner = false}) => ifElse(
  equals(true),
  () => nextDropdown(null),
  () => ifElse(
    equals(false),
    () => nextDropdown(DROPDOWN_ID),
    always(null)
  )(isInner)
)(isActive(activeDropdown))

const mapStateToProps = state => ({
  activeDropdown: state.activeDropdown,
  book: state.reader.book,
  bookInfo: state.reader.bookInfo
})

const mapDispatchToProps = (dispatch) => ({
  nextDropdown: (id) => dispatch(nextDropdown(id))
})

const handlers = withHandlers({
  toggleMenu
})

export const enhance = compose(
  setDisplayName('BookInfo'),
  connect(mapStateToProps, mapDispatchToProps),
  withPropsOnChange(['activeDropdown'], ({activeDropdown}) => ({
    active: isActive(activeDropdown)
  })),
  handlers
)

const removeLinksFromAnnotation = (str) => {
  return str.replace(/<a[^>]+>/g, '')
}

const View = ({toggleMenu, active, book, bookInfo}) => (
  <div className="BookInfo">
    <button className="book-info-btn icon-btn" onClick={toggleMenu} data-active={active}></button>
    <DropdownMenu active={active}>
      <div className="BookInfo__header Dropdown__header">
        <span className="BookInfo__header-text">{getLocaleString('reader.bookInfoTitle')}</span>
        <button className="btn btn-close-white icon-btn" onClick={toggleMenu} data-active={active}></button>
      </div>
      <div className="BookInfo__content limit-content-height">
        <Scrollbars style={{ width: 315, height: 432 }}
                    renderTrackHorizontal={props => <div {...props} style={{display: 'none'}} className="track-horizontal"/>}>
          <div className="BookInfo__list">
            <div className="line">
              <span className="line-title">{getLocaleString('reader.fileName')}</span>
              <span className="line-text">{book.name}</span>
            </div>
            {bookInfo.authors && bookInfo.authors.length > 0 ? <div className="line">
              <span className="line-title">{getLocaleString('reader.authors')}</span>
              <span className="line-text">{bookInfo.authors[0]}</span>
            </div> : ''}
            {book.metadata && book.metadata.annotation ?
              <div className="line">
                <span className="line-title">{getLocaleString('reader.annotation')}</span>
                <div className="line-text" dangerouslySetInnerHTML={{ __html: removeLinksFromAnnotation(book.metadata.annotation) }}></div>
              </div>
              : ''}
            {book.metadata && book.metadata.publisher ?
              <div className="line">
                <span className="line-title">{getLocaleString('reader.publisher')}</span>
                <span className="line-text">{book.metadata.publisher}</span>
              </div>
              : ''}
            {bookInfo.series ?
              <div className="line">
                <span className="line-title">{getLocaleString('reader.series')}</span>
                <span className="line-text">{bookInfo.series}</span>
              </div>
              : ''}
            {bookInfo.publishYear ? <div className="line">
              <span className="line-title">{getLocaleString('reader.year')}</span>
              <span className="line-text">{bookInfo.publishYear}</span>
            </div> : ''}
            <div className="line">
              <span className="line-title">{getLocaleString('reader.format')}</span>
              <span className="line-text">{bookInfo.format}</span>
            </div>
            {bookInfo.isbn && bookInfo.isbn.length > 0 ? <div className="line">
              <span className="line-title">{getLocaleString('reader.isbn')}</span>
              <span className="line-text">{bookInfo.isbn}</span>
            </div> : ''}
            <div className="line">
              <span className="line-title">{getLocaleString('reader.fileSize')}</span>
              <span className="line-text">{formatBytes(book.bytes)}</span>
            </div>
          </div>
        </Scrollbars>
      </div>
    </DropdownMenu>
  </div>
)

export const BookInfo = enhance(View)


// WEBPACK FOOTER //
// ./src/components/Reader/components/Navigation/components/BookInfo/BookInfo.js